import React from "react";

import { AboutPC } from "./about.pc";

export const About: React.FC<any> = () => {
  return <AboutPC />;
};
